module.exports = __webpack_public_path__ + "img/qipao@2x.d7a4dd27.png";